import { Button, EpicIcons } from "@constellation-academy/epic-ui";
import { OrderList } from "primereact/orderlist";
import React from "react";
import { useDialogLogic } from "@hooks/use-dialog-logic";
import { useTranslation } from "@i18n/hooks";
import { H1Span } from "@themes/font-tags";
import { CreatePageButton } from "./create-page-button";
import { EditPageButton } from "./edit-page-button";
import { headerClass, orderListActionsClass, orderListItemClass } from "./pages-editor.styles";
import { PageItem, PagesEditorProps } from "./pages-editor.types";

export const PagesEditor = ({
	onDeletePage,
	onShowEditPage,
	onShowCreatePage,
	onRearrangePages,
	pages,
	title,
	createLabel,
}: PagesEditorProps) => {
	const { t } = useTranslation("common");
	const { showDialog, dialogComponent } = useDialogLogic();

	const resolvedTitle = title ?? t("messageDefinition.pages");
	const resolvedCreateLabel = createLabel ?? t("messageDefinition.addPage");

	const deletePageWithConfirmation = (pageId: string) => {
		showDialog({
			title: t("pages.deleteTitle"),
			content: t("pages.deleteConfirm"),
			dialogCallback: (result) => {
				if (result === "Accept") {
					onDeletePage(pageId);
				}
			},
		});
	};

	return (
		<>
			{dialogComponent}
			<div className={headerClass}>
				<H1Span>{resolvedTitle}</H1Span>
				<CreatePageButton
					onCreatePage={onShowCreatePage}
					createPageButtonLabel={resolvedCreateLabel}
				/>
			</div>
			<OrderList
				value={pages}
				dragdrop={true}
				onChange={(event) =>
					onRearrangePages(event.value.map((item: { id: string }) => item.id))
				}
				itemTemplate={(item: PageItem) => {
					return (
						<div key={item.id} className={orderListItemClass}>
							{item.title}

							<div className={orderListActionsClass}>
								{item && (
									<EditPageButton onEditPage={() => onShowEditPage(item.id)} />
								)}
								<Button
									disabled={pages?.length === 1}
									icon={EpicIcons.TRASH}
									onClick={() => deletePageWithConfirmation(item.id)}
								/>
							</div>
						</div>
					);
				}}
			/>
		</>
	);
};
